<template>
    <v-container pa-0>
        <build-stepper-form ref="form-builder"
                            :stepper.sync="stepper"
                            :errors.sync="errors"
                            :validStep.sync="validStep"
                            :dateModal.sync="dateModal"
                            :steps.sync="steps"
                            :completed.sync="completed"
                            :form.sync="form"
                            :rules="rules"/>
    </v-container>
</template>
<script>
    // 3rd
    import {
        mapActions,
        mapState
    } from 'vuex';
    // components
    import BuildStepperForm from '../../components/Builders/BuildStepperForm';
    // utils
    import { transformArrayToSelectValues, } from '../../utils/helper';
    import {
        api,
        parseErrors
    } from '../../utils/api';
    import {
        API_ENDPOINT_REGISTER_PARTICIPANT,
        LOADER_SUBMIT_REGISTER,
        ROUTE_REGISTER_CONFIRMATION,
    } from '../../utils/constants';
    import { setPageTitle } from '../../utils/helper';
    import {
        birth_date,
        business_email,
        business_phone,
        city,
        company_id,
        country,
        employment_type,
        first_name,
        last_name,
        password,
        password_confirmation,
        private_email,
        private_phone,
        salutation,
        street,
        street_number,
        terms_and_conditions,
        zip_code,
    } from '../../utils/formRules';

    export default {
        name: 'register-participant',
        components: {
            BuildStepperForm,
        },
        data() {
            return {
                stepper: 1,

                errors: {},
                validStep: [],

                dateModal: [],

                completed: false,

                form: {
                    gender: '',
                    last_name: '',
                    first_name: '',
                    email: '',

                    business_email: null,
                    business_phone: null,
                    company_id: '',
                    employment_type: '',

                    private_address_street: '',
                    private_address_number: '',
                    private_address_zip: '',
                    private_address_city: '',
                    private_address_country: '',
                    private_phone: '',
                    birth_date: null,

                    password: '',
                    password_confirmation: '',
                    terms_and_conditions: false,
                },
                rules: {
                    salutation,
                    last_name,
                    first_name,
                    private_email,

                    business_email,
                    business_phone,
                    company_id,
                    employment_type,

                    street,
                    street_number,
                    zip_code,
                    city,
                    country,
                    birth_date,
                    private_phone,

                    password,
                    password_confirmation,
                    terms_and_conditions,
                },
            }
        },
        computed: {
            ...mapState([
                'genders',
                'employmentTypes',
            ]),
            salutations() {
                return transformArrayToSelectValues(this.genders, '$vuetify.salutation.');
            },
            employment_types() {
                return transformArrayToSelectValues(this.employmentTypes, '$vuetify.employment_type.');
            },
            steps() {
                return [
                    // step 1
                    {
                        title: '$vuetify.register.participant_step1.headline',
                        description: '$vuetify.register.participant_step1.desc',
                        formItems: [
                            {
                                is: 'select',
                                name: 'gender',
                                label: '$vuetify.form_items.salutation',
                                options: this.salutations,
                                rule: 'salutation',
                            },
                            {
                                is: 'text',
                                name: 'last_name',
                            },
                            {
                                is: 'text',
                                name: 'first_name',
                            },
                            {
                                is: 'text',
                                name: 'email',
                                label: '$vuetify.form_items.private_email',
                                rule: 'private_email',
                                hint: '$vuetify.form_item_hints.private_email',
                            },
                        ],
                        actions: [
                            {
                                is: 'next',
                            },
                        ],
                    },
                    // step 2
                    {
                        title: '$vuetify.register.participant_step2.headline',
                        description: '$vuetify.register.participant_step2.desc',
                        formItems: [
                            {
                                is: 'text',
                                name: 'company_id',
                            },
                            {
                                is: 'select',
                                name: 'employment_type',
                                options: this.employment_types,
                            },
                            {
                                is: 'text',
                                name: 'business_email',
                                hint: '$vuetify.form_item_hints.business_email',
                                optionalBy: 'employment_type:freelancer',
                            },
                            {
                                is: 'phone',
                                name: 'business_phone',
                                optionalBy: 'employment_type:freelancer',
                            },
                        ],
                        actions: [
                            {
                                is: 'previous',
                            },
                            {
                                is: 'next',
                            },
                        ],
                    },
                    // step 3
                    {
                        title: '$vuetify.register.participant_step3.headline',
                        description: '$vuetify.register.participant_step3.desc',
                        formItems: [
                            {
                                is: 'text',
                                label: '$vuetify.form_items.street',
                                name: 'private_address_street',
                                rule: 'street',
                                width: 8,
                            },
                            {
                                is: 'text',
                                label: '$vuetify.form_items.street_number',
                                name: 'private_address_number',
                                rule: 'street_number',
                                width: 4,
                            },
                            {
                                is: 'text',
                                label: '$vuetify.form_items.zip_code',
                                name: 'private_address_zip',
                                rule: 'zip_code',
                                width: 5,
                            },
                            {
                                is: 'text',
                                label: '$vuetify.form_items.city',
                                name: 'private_address_city',
                                rule: 'city',
                                width: 7,
                            },
                            {
                                is: 'date',
                                name: 'birth_date',
                            },
                            {
                                is: 'phone',
                                name: 'private_phone',
                            },
                        ],
                        actions: [
                            {
                                is: 'previous',
                            },
                            {
                                is: 'next',
                            },
                        ],
                    },
                    // step 4
                    {
                        title: '$vuetify.register.participant_step4.headline',
                        description: '$vuetify.register.participant_step4.desc',
                        formItems: [
                            {
                                is: 'password',
                                name: 'password',
                            },
                            {
                                is: 'password',
                                name: 'password_confirmation',
                            },
                            {
                                is: 'checkbox',
                                label: '$vuetify.form_items.data_protection_and_conditions_of_participation',
                                linkName: '$vuetify.form_items.data_protection_link',
                                linkName2: '$vuetify.form_items.terms_link',
                                slug: 'data_protection',
                                slug2: 'terms',
                                tooltip: '$vuetify.tooltips.new_window',
                                name: 'terms_and_conditions',
                            },
                        ],
                        actions: [
                            {
                                is: 'previous',
                            },
                            {
                                is: 'button',
                                name: 'finalize',
                                color: 'primary',
                                clickMethod: this.submit,
                            },
                        ],
                    },
                ];
            },
            whileSubmitting() {
                return this.$wait.waiting('submit-register');
            },
        },
        methods: {
            ...mapActions('confirmation', [
                'writeConfirmation',
            ]),
            submit() {
                if (!this.$refs['form-builder'].validateCurrentFormBeforeSubmit()) return false;

                this.$wait.start(LOADER_SUBMIT_REGISTER);

                this.form.locale = this.$i18n.locale;

                // remove fields if optional and not set!
                this.form.business_email = this.form.business_email === '' ? null : this.form.business_email;
                this.form.business_phone = this.form.business_phone === '' ? null : this.form.business_phone;

                api.post(API_ENDPOINT_REGISTER_PARTICIPANT, this.form)
                    .then(response => {
                        const { data } = response;
                        this.$wait.end('submit-register');
                        this.writeConfirmation({
                            headline: '$vuetify.confirmation.register_participant_headline',
                            description: data.message,
                        });
                        this.$router.push({
                            name: ROUTE_REGISTER_CONFIRMATION,
                        });
                    })
                    .catch(error => {
                        this.$wait.end(LOADER_SUBMIT_REGISTER);
                        this.errors = parseErrors(error);
                    });
            },
            resetValidation(step) {
                this.$wait.end(LOADER_SUBMIT_REGISTER);
                this.$refs[`formStep${step}`].resetValidation();
            },
        },
    }
</script>
